<div class="card col-lg-12 col-md-12 col-sm-12">
  <div class="card-header">
    <h4 class="card-title" id="basic-layout-form">{{ 'emailSettings.title' | translate }}</h4>
    <p class="mb-0">{{ 'emailSettings.text' | translate }}</p>
  </div>
  <div class="card-body">
    <div class="px-3">
      <form class="form" #settingsForm="ngForm" (ngSubmit)="onSubmit(settingsForm)">
        <div class="form-body">
          <h4 class="form-section">
            <i class="ft-cpu"></i> {{ 'emailSettings.detailsHeader' | translate }}</h4>

          <div class="form-group">
            <label for="MailSender">Sender Email Address</label>
            <input class="form-control" id="MailSender" name="MailSender" #MailSender="ngModel"
                   [(ngModel)]="this.currentObject.MailSender"
                   placeholder="Sender Email Address">
          </div>

          <div class="form-group">
            <label for="Smtp Host">Smtp Host</label>
            <input class="form-control" name="MailHost" #MailHost="ngModel" [(ngModel)]="this.currentObject.MailHost"
                   placeholder="Smtp Host" required="true">
          </div>

          <div class="form-group">
            <label for="Smtp Port">Smtp Port</label>
            <input type="number" class="form-control" name="MailPort" #MailPort="ngModel"
                   [(ngModel)]="this.currentObject.MailPort"
                   placeholder="Smtp Port" required="true">
          </div>

          <div class="form-group">
            <label for="Username">Username</label>
            <input class="form-control" id="Username" name="MailUsername" #MailUsername="ngModel"
                   [(ngModel)]="this.currentObject.MailUsername"
                   placeholder="Username">
          </div>

          <div class="form-group">
            <label for="Password">Password</label>

            <div class="input-group">
              <input [type]="passwordType" class="form-control" name="MailPassword" #MailPassword="ngModel"
                     placeholder="Password"
                     [(ngModel)]="this.currentObject.MailPassword" (dblclick)="togglePassword()">
              <div class="input-group-append">
                  <span class="input-group-text">
                    <a data-original-title="" title="toggle" (click)="togglePassword()">
                      <i [ngClass]="passwordIconClass"></i>
                    </a>
                  </span>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="MailEncryptionNumber">Email Encryption</label>

            <div class="form-check">
              <input type="radio" required class="form-check-input" id="MailEncryptionNumber" [value]="0"
                     name="MailEncryptionNumber" [(ngModel)]="currentObject.MailEncryptionNumber">
              <label class="form-check-label" for="EncryptionNone">None</label>
            </div>
            <div class="form-check">
              <input type="radio" class="form-check-input" id="MailEncryptionNumber" [value]="1"
                     name="MailEncryptionNumber" [(ngModel)]="currentObject.MailEncryptionNumber">
              <label class="form-check-label" for="EncryptionSSL">SSL</label>
            </div>
            <div class="form-check">
              <input type="radio" class="form-check-input" id="MailEncryptionNumber" [value]="2"
                     name="MailEncryptionNumber" [(ngModel)]="currentObject.MailEncryptionNumber">
              <label class="form-check-label" for="EncryptionSTARTTLS">STARTTLS</label>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn btn-raised btn-raised btn-warning mr-1" type="button" (click)="resetForm(settingsForm)">
            <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
          </button>
          <button [disabled]="!settingsForm.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
            <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
          </button>
          <button [disabled]="!settingsForm.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="button"
                  (click)="testConnection(settingsForm)">
            <i class="fa fa-check"></i> {{ 'buttons.testSettingsText' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
